import { render, staticRenderFns } from "./ChangeMobileForm.vue?vue&type=template&id=568a9fbc"
import script from "./ChangeMobileForm.vue?vue&type=script&lang=js"
export * from "./ChangeMobileForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports